import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import SearchBar from "../../../../Components/Utils/SearchBar";
import {
  BackButton,
  ClearFilterButton,
  CreateButton,
  EditButton,
  ExportButton,
  FilterButton,
  ImportButton,
} from "../../../../Components/Utils/Buttons";
import { GetAccess } from "../../../../Components/Utils/roles";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import axiosInstance from "../../../../Services/axiosCommon";
import { useClients } from "./ClientContext";

const ClientLayout = ({
  setSearchQuery = () => {},

  EditAccess = false,

  children,

  isFilter = false,
  setFilterOpen = () => {},
  newfilter = false,
  ClearFilter = () => {},
}) => {
  let { pathname } = useLocation();
  const [module, setModule] = useState("");

  const navigate = useNavigate();
  const { clientViewId } = useParams();
  const {
    clientInspectionView,
    clientContaractView,
    clientEquipmentsView,
    clientServiceView,
    clientInvoiceView,
    isClientViewUpdate,
    updateClientContaract,
    updateClientInspection,
    updateClientEquipments,
    updateClientService,
    updateClientInvoice,
    updateIsClientViewUpdate
  } = useClients();

  const location = useLocation();
  const data = location.state?.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;

  let searchList = [
    { value: "all", label: "All" },
    { value: "services", label: "Services" },
    { value: "products", label: "Products" },
  ];

  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (pathname == `/client-management/clients/view/${clientViewId}`) {
      setModule("Details");
    } else if (
      pathname == `/client-management/clients/contracts/${clientViewId}`
    ) {
      setModule("Contracts");
    } else if (
      pathname == `/client-management/clients/inspection/${clientViewId}`
    ) {
      setModule("Inspection");
    } else if (
      pathname == `/client-management/clients/equipments/${clientViewId}`
    ) {
      setModule("Equipment");
    } else if (
      pathname == `/client-management/clients/service/${clientViewId}`
    ) {
      setModule("Service");
    } else if (
      pathname == `/client-management/clients/invoice/${clientViewId}`
    ) {
      setModule("Invoice");
    }
  }, [pathname]);


    function getTabFuction() {
    axiosInstance.get(`/clients/${clientViewId}`).then(res=>{
      if(res?.data){
        const { inspection, equipments, service, invoice,contract } = res?.data?.data?.tabs;
        updateIsClientViewUpdate(true);
        updateClientContaract(contract)
        updateClientInspection(inspection);
        updateClientEquipments(equipments);
        updateClientService(service);
        updateClientInvoice(invoice);
      }
    }).catch(err=>{
      console.log(err);
      
    })
  }

  useEffect(() => {
    if(isClientViewUpdate == false){
      getTabFuction();
    }
  },[isClientViewUpdate,clientViewId])

  const NavTab = [
    {
      label: "Details",
      link: `/client-management/clients/view/${clientViewId}`,
      view: true,
      key: "clients_view",
    },
    {
      label: "Contracts",
      link: `/client-management/clients/contracts/${clientViewId}`,
      key: "clients_contract",
      view: clientContaractView || false,
    },

    {
      label: "Inspection",
      link: `/client-management/clients/inspection/${clientViewId}`,
      key: "clients_inspection",
      view: clientInspectionView || false,
    },
    {
      label: "Equipment",
      link: `/client-management/clients/equipments/${clientViewId}`,
      key: "clients_equipments",
      view: clientEquipmentsView || false,
    },
    {
      label: "Service",
      link: `/client-management/clients/service/${clientViewId}`,
      key: "clients_service",
      view: clientServiceView || false,
    },
    {
      label: "Invoice",
      link: `/client-management/clients/invoice/${clientViewId}`,
      key: "clients_invoice",
      view: clientInvoiceView || false,
    },
    
  ];

  return (
    <div className=" w-full  h-full py-2 px-4 md:overflow-hidden">
      <div className="sm:flex justify-between w-full ">
        <Breadcrumb
          items={[
            // { name: "Client-Management" },
            {
              name: "Client",
              link: "/client-management/clients",
            },

            { name: module },
          ]}
        />
        <div className="flex gap-2 justify-end">
          {newfilter && (
            <>
              <FilterButton
                label="Filter"
                handleClick={() => {
                  setFilterOpen(true);
                  setSearchQuery("");
                }}
              />
              {isFilter && (
                <ClearFilterButton label="Clear" handleClick={ClearFilter} />
              )}{" "}
            </>
          )}
          <div className=" flex justify-end items-center gap-3 ">
            <div className=" flex gap-2">
              {/* <Link
                to={`/client-management/clients`}
                state={{
                  currentPage: pageIndex,
                  searchQuery: searchQuery != "" ? searchQuery : "",
                }}
              >
                <BackButton link={true} />
              </Link> */}

               <BackButton
                link={true}
                hasLink={
                  module !== "Details"
                    ? `/client-management/clients`
                    : `/client-management/clients`
                }
                state={
                  module === "Details"
                    ? {
                        currentPage: pageIndex,
                        searchQuery: searchQuery !== "" ? searchQuery : "",
                      }
                    : null
                }
              />
              {EditAccess && (
                <Link
                  to={`/client-management/clients/edit/${clientViewId}`}
                  state={{
                    data: data,
                    from: `/client-management/clients/view/${clientViewId}`,
                  }}
                >
                  <EditButton height="8" />
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="w-full overflow-x-auto whitespace-nowrap scrollbar-hide">
        <div className="inline-flex items-center gap-x-1">
            {NavTab &&
              NavTab.map((item, i) => {
                const isActive = item?.link === pathname;
                return (
                  <React.Fragment key={item?.link || i}>
                    {GetAccess(item?.key) && item?.view === true && (
                      <Link
                        to={item?.link}
                        className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5 inline-block
                ${
                  isActive
                    ? "bg-baseColor-primary text-white"
                    : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                }`}
                      >
                        {item?.label || ""}
                      </Link>
                    )}
                  </React.Fragment>
                );
              })}
        </div>
      </div>

      <div className=" w-full h-[calc(100vh-211px)] md:h-[calc(100vh-160px)]  ">{children}</div>
    </div>
  );
};

export default ClientLayout;
